import { KeyValue } from "@angular/common";

export const valueAscOrder = <K = number, V = string>(
  a: KeyValue<K, V>,
  b: KeyValue<K, V>,
): number => (a.value > b.value ? 1 : -1);
